import React from 'react';
import CV from '../assets/Resume.pdf'; 

const Resume = () => {
  window.location.href = CV; 

  return (
    <div>
      <p>If the PDF does not open, <a href={CV}>click here to view it</a>.</p>
    </div>
  );
};

export default Resume;
